import { Button, styled } from "@mui/material";
import { ICustomButtonProps, getSizeStyles } from "./CustomBtnResources";

// TertiaryButton.js
const TertiaryButton = ({
  disabled,
  children,
  onClick,
  style,
  size = "large",
  nativeType,
  type = "primary",
  loading = false,
  loadingText = "Loading...",
  preImg,
  postImg,
}: ICustomButtonProps) => {
  const TerButton = styled(Button)`
    && {
      text-transform: none;
      font-weight: 500;
      color: #fdd649;
      gap: 8px;
      width: auto;
      padding: 0;
      // padding: ${getSizeStyles(size, type).padding};
      font-size: ${getSizeStyles(size, type).fontSize};
      line-height: ${getSizeStyles(size, type).lineHeight};
      &:hover {
        background-color: transparent;
        color: #fee38b;
      }
      &:active {
        background-color: transparent;
        color: #feefc3;
      }
      &:disabled {
        background-color: transparent;
        color: #696969;
      }
    }
  `;

  return (
    <TerButton
      type={nativeType}
      disabled={disabled}
      onClick={onClick}
      style={style}
    >
      {!loading && preImg && typeof preImg === "string" ? (
        <img
          src={preImg}
          alt="preImg"
          style={{ display: "flex" }}
          width={size === "large" || type === "onBoarding" ? 24 : 18}
          height={size === "large" || type === "onBoarding" ? 24 : 18}
        />
      ) : (
        !loading && preImg && <div style={{ display: "flex" }}>{preImg}</div>
      )}
      {!loading ? children : loadingText}
      {!loading && postImg && typeof postImg === "string" ? (
        <img
          src={postImg}
          style={{ display: "flex" }}
          alt="postImg"
          width={size === "large" ? 24 : 18}
          height={size === "large" ? 24 : 18}
        />
      ) : (
        !loading && postImg && <div style={{ display: "flex" }}>{postImg}</div>
      )}
    </TerButton>
  );
};

export default TertiaryButton;
